export const gZOAppsString = {
  OK: "KK",
  Cancel: "Naw",
  Yes: "Ye",

  Save: "Fact",
  Exit: "Cap",

  "Save Changes": "Yeet",
  "Discard Changes": "Hell Naw",

  Alert: "Yikers",
  Error: "Big Yikers",

  Refresh: "Reeeefresh",
  "Point In Time": "Rewind Time"
};
